import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { protectedResources } from '../types/authConfig';
const useCustomEvents = (videoVersionId: any) => {
  const secret = 'a6f8E$4vYd@9JpZ1Lw$Xr4pFm7!TqB9u';
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [loading, setLoading] = useState<boolean>(!token);
  const [userIP, setUserIP] = useState('');
  const [userInfo, setUserInfo] = useState<any>(null);
  useEffect(() => {
    if (!localStorage.getItem('uniqueIdentifier')) {
      const uniqueIdentifier = uuidv4();
      localStorage.setItem('uniqueIdentifier', uniqueIdentifier);
    }

    const fetchToken = async () => {
      try {
        const response = await fetch(`${protectedResources.apiTodoList.endpoint}player/auth/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ secret }),
        });
        if (!response.ok) {
          throw new Error('Failed to fetch token');
        }
        const data = await response.json();
        setToken(data.access_token);
        setLoading(false);
        localStorage.setItem('token', data.access_token);
      } catch (error) {
        console.error('Error fetching token:', error);
      } finally {
        const userInfo = JSON.stringify({
          unique_identifier: localStorage.getItem('uniqueIdentifier'),
        });
        setUserInfo(userInfo);
        setLoading(false);
      }
    };

    fetchToken();
  }, [secret]);

  useEffect(() => {
    if (userInfo && videoVersionId) {
      sendEvent({
        video_version_id: videoVersionId,
        user_info: userInfo,
        event_type: 'access_player',
        event_data: '',
      });
    }
  }, [videoVersionId, userInfo]);

  const sendEvent = async (payload: {
    video_version_id: string;
    event_type: string;
    event_data: string; // JSON string
    user_info: string; //JSON string
  }) => {
    if (loading) {
      console.error('Token is loading, cannot send event yet');
      return;
    }

    if (!token) {
      console.error('No token available for authentication');
      return;
    }

    try {
      const response = await fetch(`${protectedResources.apiTodoList.endpoint}player/invoke/event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to send event');
      }

      const data = await response.json();
      console.log('Event sent successfully:', data);
    } catch (error) {
      console.error('Error sending event:', error);
    }
  };

  return { sendEvent, userIP, userInfo };
};

export default useCustomEvents;
